import { render, staticRenderFns } from "./changePasswordDialog.vue?vue&type=template&id=27d6c5a6&scoped=true&"
import script from "./changePasswordDialog.vue?vue&type=script&lang=js&"
export * from "./changePasswordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d6c5a6",
  null
  
)

export default component.exports